import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cea68e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "layout-list" }
const _hoisted_3 = { class: "left-box" }
const _hoisted_4 = { class: "row between" }
const _hoisted_5 = { class: "black title" }
const _hoisted_6 = { class: "black" }
const _hoisted_7 = { class: "grey" }
const _hoisted_8 = { class: "layout-list" }
const _hoisted_9 = { class: "left-box" }
const _hoisted_10 = { class: "row between" }
const _hoisted_11 = { class: "black title" }
const _hoisted_12 = { class: "black" }
const _hoisted_13 = { class: "grey" }

import { onActivated, onMounted, reactive, ref, watch } from 'vue'
import { getFeeList, getPaymentList } from '@/apis/projectDetail'
import { useRouter } from 'vue-router'
import dayjs from 'dayjs'
import _lodash from '@/utils/lodashUtil'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const costActive = ref(0)
const project_id = ref(0)
const state = reactive({
  page: 1,
  page1: 1,
  feeList: [],
  paymentList: []
})
const loading = ref(false)
const finished = ref(false)
const refreshing = ref(false)
const refreshing1 = ref(false)

const costClickTab = val => {
  console.log('costClickTab', val)
  if (val.name === 0) {
    state.feeList = []
    onRefreshfee()
  }
  if (val.name === 1) {
    state.paymentList = []
    onRefreshpayment()
  }
}

const get_fee_List = async () => {
  let data = {
    project_id: project_id.value,
    page: state.page,
    page_size: 10
  }
  const res = await getFeeList(data)
  if (res.code === 200) {
    console.log(res.data.data)

    finished.value = false
    if (refreshing.value) {
      state.feeList = []
      refreshing.value = false
    }
    state.page += 1
    state.feeList = _lodash.uniq(_lodash.concat(state.feeList, res.data.data))
    loading.value = false
    if (state.page > res.data.last_page) {
      // 已到最后一页
      finished.value = true
    }
    console.log(state.feeList)
  }
}
const get_payment_List = async () => {
  let data = {
    project_id: project_id.value,
    page: state.page1,
    page_size: 10
  }
  const resq = await getPaymentList(data)
  if (resq.code === 200) {
    finished.value = false
    if (refreshing1.value) {
      state.paymentList = []
      refreshing1.value = false
    }
    state.page1 += 1
    state.paymentList = _lodash.uniq(_lodash.concat(state.paymentList, resq.data.data))
    loading.value = false
    if (state.page1 > resq.data.last_page) {
      // 已到最后一页
      finished.value = true
    }
    console.log(state.paymentList)
  }
}
const onRefreshfee = () => {
  // 清空列表数据
  finished.value = false
  state.page = 1
  // 重新加载数据
  // 将 loading 设置为 true，表示处于加载状态
  loading.value = true
  get_fee_List()
}
const onRefreshpayment = () => {
  // 清空列表数据
  finished.value = false
  state.page1 = 1
  // 重新加载数据
  // 将 loading 设置为 true，表示处于加载状态
  loading.value = true
  get_payment_List()
}

onMounted(() => {
  project_id.value = Number(router.currentRoute.value.query.project_id)
})

//格式时间
const formatDate = date => {
  return `${dayjs(date).format('YYYY-MM-DD')}`
}

return (_ctx: any,_cache: any) => {
  const _component_base_nav_bar = _resolveComponent("base-nav-bar")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-text": "返回"
    }, null, 8, ["title"]),
    _createVNode(_component_van_tabs, {
      active: costActive.value,
      "onUpdate:active": _cache[4] || (_cache[4] = ($event: any) => ((costActive).value = $event)),
      onClickTab: costClickTab
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_tab, { title: "费用申报" }, {
          default: _withCtx(() => [
            _createVNode(_component_van_pull_refresh, {
              modelValue: refreshing.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((refreshing).value = $event)),
              onRefresh: onRefreshfee
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_list, {
                  loading: loading.value,
                  "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event)),
                  finished: finished.value,
                  "finished-text": "没有更多了",
                  onLoad: get_fee_List
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).feeList, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "row row-layout-box",
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                              _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("span", null, _toDisplayString(item.details[0].type.pname), 1)
                              ]),
                              _createElementVNode("div", _hoisted_6, [
                                _createTextVNode("￥" + _toDisplayString(item.total_money), 1),
                                _createVNode(_component_van_icon, { name: "arrow" })
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_7, _toDisplayString(item.created_at.substring(0, 10)), 1)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }, 8, ["loading", "finished"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_van_tab, { title: "项目回款" }, {
          default: _withCtx(() => [
            _createVNode(_component_van_pull_refresh, {
              modelValue: refreshing1.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((refreshing1).value = $event)),
              onRefresh: onRefreshpayment
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_list, {
                  loading: loading.value,
                  "onUpdate:loading": _cache[2] || (_cache[2] = ($event: any) => ((loading).value = $event)),
                  finished: finished.value,
                  "finished-text": "没有更多了",
                  onLoad: get_payment_List
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).paymentList, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "row row-layout-box",
                          key: item.id
                        }, [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("div", _hoisted_11, _toDisplayString(item.type_name), 1),
                              _createElementVNode("div", _hoisted_12, [
                                _createTextVNode("￥" + _toDisplayString(item.money), 1),
                                _createVNode(_component_van_icon, { name: "arrow" })
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_13, _toDisplayString(item.date), 1)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }, 8, ["loading", "finished"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["active"])
  ]))
}
}

})